module.exports = __webpack_public_path__ + "img/move.98a29dce.svg";